import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../components/AuthContext";

// Handles return from Emergent Google OAuth.
// On mount: if URL hash contains session_id, exchange it for our JWT cookies, then hard-navigate to /dashboard.
export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      // direct visit, just go to dashboard (auth check will redirect to /login if needed)
      navigate("/dashboard", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    completeGoogle(session_id)
      .then(() => {
        // Hard-navigate (not React Router navigate) so DashboardRoute is freshly
        // evaluated without the #session_id hash. A soft navigate to the same
        // pathname is a no-op in React Router v6 and would leave AuthCallback
        // mounted indefinitely.
        window.location.replace("/dashboard");
      })
      .catch((err) => setError(formatApiError(err)));
  }, [completeGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-heading text-2xl text-[var(--ink)]" style={{ fontWeight: 500 }}>
          {error ? "Sign-in failed" : "Signing you in…"}
        </div>
        <div className="overline mt-2">{error || "Verifying your Google session"}</div>
        {error && (
          <button onClick={() => navigate("/login", { replace: true })} className="btn-primary mt-6" data-testid="auth-callback-retry">
            Back to login
          </button>
        )}
      </div>
    </div>
  );
}
